export const BagIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
  >
    <rect
      width="40"
      height="40"
      fill="#E2E2F7"
      fillOpacity="0.2"
      rx="20"
    ></rect>
    <path
      stroke="#068EC3"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M11 14.3v14.2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V14.3z"
    ></path>
    <path
      stroke="#068EC3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m29 14.3-2.833-3.8H13.833L11 14.3M23.778 17.6c0 2.099-1.692 3.8-3.778 3.8s-3.778-1.701-3.778-3.8"
    ></path>
  </svg>
);